import { Routes, Route, Link, useLocation } from 'react-router-dom'
import HospitalManager from '../components/HospitalManager'
import RoomManager from '../components/RoomManager'
import EmergencyManager from '../components/EmergencyManager'
import { useAuth } from '../contexts/AuthContext'

function AdminDashboard() {
  const { user, logout } = useAuth()
  const location = useLocation()
  
  return (
    <div className="container">
      <div className="header">
        <h1>👨‍⚕️ Admin Dashboard</h1>
        <p>Manage hospitals, rooms, and emergency alerts • Welcome, {user?.username}!</p>
      </div>
      
      <div className="card">
        <div className="dashboard-header">
          <div className="nav-tabs">
            <Link 
              to="/dashboard" 
              className={`nav-tab ${location.pathname === '/dashboard' ? 'active' : ''}`}
            >
              🚨 Emergencies
            </Link>
            <Link 
              to="/dashboard/hospitals" 
              className={`nav-tab ${location.pathname === '/dashboard/hospitals' ? 'active' : ''}`}
            >
              🏥 Hospitals
            </Link>
            <Link 
              to="/dashboard/rooms" 
              className={`nav-tab ${location.pathname === '/dashboard/rooms' ? 'active' : ''}`}
            >
              🏠 Rooms
            </Link>
          </div>
          
          <button onClick={logout} className="btn btn-secondary">
            Logout
          </button>
        </div>
        
        <Routes>
          <Route path="/" element={<EmergencyManager />} />
          <Route path="/hospitals" element={<HospitalManager />} />
          <Route path="/rooms" element={<RoomManager />} />
        </Routes>
      </div>
    </div>
  )
}

export default AdminDashboard